import * as React from "react";
import { useMemo, useState } from "react";
import { GB, HU } from "country-flag-icons/react/3x2";
import Box from "@mui/material/Box";
import { IconButton, Menu, MenuItem } from "@mui/material";
import { useTranslation } from "react-i18next";

export default function LanguageSelect() {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleOpenMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const { i18n } = useTranslation(["auth", "validation", "common"]);

  const handleClose = () => {
    setAnchorEl(null);
  };

  const setLanguage = (newLanguage) => {
    if (i18n.language !== newLanguage) i18n.changeLanguage(newLanguage);
    handleClose();
  };

  const LanguageIconWrapper = ({ children }) => (
    <Box
      sx={{
        width: "25px",
        height: "25px",
        display: "flex",
        alignItems: "center",
      }}
    >
      {children}
    </Box>
  );

  const iconsByLocale = useMemo(
    () => ({
      en: <GB />,
      hu: <HU />,
    }),
    []
  );

  return (
    <>
      <IconButton
        id="language-menu-button"
        aria-controls={open ? "language-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        aria-label="language"
        onClick={handleOpenMenu}
      >
        <LanguageIconWrapper>
          {iconsByLocale[i18n.language.slice(0, 2)]}
        </LanguageIconWrapper>
      </IconButton>
      <Menu
        id="language-menu"
        anchorEl={anchorEl}
        open={open}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        transformOrigin={{ vertical: "top", horizontal: "center" }}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "language-menu-button",
        }}
      >
        {Object.keys(iconsByLocale).map((x) => (
          <MenuItem key={x} onClick={() => setLanguage(x)}>
            <LanguageIconWrapper>{iconsByLocale[x]}</LanguageIconWrapper>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
